import * as React from "react";
import { AgGridColumn, AgGridReact, Button, Icon, Intent, } from "../../externals";
export const newPropertyDefaultText = "newProperty";
export const newValueDefaultText = "newValue";
export class PropertyValueTable extends React.PureComponent {
    constructor(props) {
        super(props);
        this.gridApi = undefined;
        this.columnApi = undefined;
        this.previousInputs = [];
        this.autoSize = () => {
            var _a, _b;
            (_a = this.gridApi) === null || _a === void 0 ? void 0 : _a.sizeColumnsToFit();
            (_b = this.columnApi) === null || _b === void 0 ? void 0 : _b.autoSizeColumns(Object.keys(this.props.item), false);
        };
        this.onGridReady = (params) => {
            this.gridApi = params.api;
            this.columnApi = params.columnApi;
            this.autoSize();
            this.previousInputs = this.state.items.slice();
        };
        this.updateObject = () => {
            var _a, _b, _c, _d;
            if (this.gridApi) {
                this.gridApi.stopEditing();
            }
            const inputsObject = {};
            this.state.items.forEach((item) => {
                inputsObject[item.property] = item.value;
            });
            (_b = (_a = this.props).updateCallback) === null || _b === void 0 ? void 0 : _b.call(_a, inputsObject);
            (_d = (_c = this.props).isValidCallback) === null || _d === void 0 ? void 0 : _d.call(_c, !this.containsErrors());
            this.autoSize();
        };
        this.getRowData = (items) => {
            const agGridInputs = [];
            for (const property in items) {
                agGridInputs.push({ property: property, value: items[property] });
            }
            return agGridInputs;
        };
        this.addRow = () => {
            if (this.gridApi) {
                this.gridApi.stopEditing();
            }
            const items = this.state.items.slice();
            const newInput = {
                property: newPropertyDefaultText,
                value: newValueDefaultText,
            };
            items.push(newInput);
            this.setState({
                items: items,
            });
            this.updateObject();
        };
        this.removeRow = () => {
            const newItems = this.state.items.slice();
            if (this.state.rowIndex !== undefined) {
                newItems.splice(this.state.rowIndex, 1);
            }
            if (this.gridApi) {
                this.gridApi.setRowData(newItems);
            }
            this.setState({ items: newItems, rowIndex: undefined });
        };
        this.handleSelectoRow = (e) => {
            this.setState({ rowIndex: e.rowIndex });
        };
        this.containsErrors = () => {
            const keysArray = this.state.items.map((item) => item.property);
            const isRepeated = keysArray.some((key, index) => keysArray.indexOf(key) !== index);
            const isEmpty = keysArray.some((key) => key === "");
            return isEmpty || isRepeated;
        };
        this.state = {
            items: this.getRowData(this.props.item),
            rowIndex: undefined,
        };
    }
    render() {
        const tableHeight = 80 + this.state.items.length * 30;
        const gridOptions = {
            onRowDataUpdated: this.updateObject,
            onCellValueChanged: this.updateObject,
        };
        return (React.createElement("div", null,
            this.props.isEditable && (React.createElement("div", { style: {
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "center",
                } },
                React.createElement(Button, { large: true, minimal: true, text: "Add", icon: React.createElement(Icon, { icon: "add", size: 18, intent: Intent.SUCCESS }), onClick: this.addRow }),
                React.createElement(Button, { large: true, minimal: true, text: "Remove", disabled: this.state.rowIndex === undefined, icon: React.createElement(Icon, { icon: "remove", size: 18, intent: Intent.DANGER }), onClick: this.removeRow }))),
            React.createElement("div", { className: "ag-theme-balham", style: { width: "auto", height: tableHeight } },
                React.createElement(AgGridReact, { rowData: this.state.items, singleClickEdit: this.props.isEditable, onCellClicked: this.handleSelectoRow, onGridReady: this.onGridReady, stopEditingWhenCellsLoseFocus: true, defaultColDef: {
                        editable: false,
                        resizable: true,
                        sortable: true,
                    }, gridOptions: this.props.isEditable ? gridOptions : undefined },
                    React.createElement(AgGridColumn, { field: "property", editable: this.props.isEditable, unSortIcon: true }),
                    React.createElement(AgGridColumn, { field: "value", editable: this.props.isEditable, unSortIcon: true }))),
            this.containsErrors() ? (React.createElement("div", { style: { display: "flex", justifyContent: "center" } },
                React.createElement("span", { style: { color: "red", fontSize: "14px" } }, "Error: Item property empty or repeated"))) : null));
    }
}
//# sourceMappingURL=PropertyValueTable.js.map